import { axiosInstance } from '../axios.ts';
import { ITiledeskDashboardAccess } from './types.ts';

export function getTiledeskDashboardAccess(): Promise<ITiledeskDashboardAccess> {
  return axiosInstance.get('/tiledesk/dashboard/').then(({ data }) => data as ITiledeskDashboardAccess);
}
